/**
 * DesktopModeToggle - Zwevende knop voor desktop/mobiel weergave
 * Links onderin zichtbaar op alle pagina's
 */

import { Monitor, Smartphone } from 'lucide-react';
import { useDesktopMode } from '../contexts/DesktopModeContext';

const DesktopModeToggle = () => {
  const { desktopMode, toggleDesktopMode } = useDesktopMode();

  return (
    <button
      onClick={toggleDesktopMode}
      className="desktop-mode-toggle fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-2.5 bg-slate-800 hover:bg-slate-700 text-white rounded-full shadow-lg transition-all duration-200 hover:scale-105 print:hidden"
      data-testid="floating-desktop-mobile-toggle"
      title={desktopMode ? 'Schakel naar mobiele weergave' : 'Schakel naar desktop weergave'}
    >
      {desktopMode ? (
        <>
          <Monitor className="w-4 h-4" />
          <span className="text-sm font-medium">Desktop</span>
        </>
      ) : (
        <>
          <Smartphone className="w-4 h-4" />
          <span className="text-sm font-medium">Mobiel</span>
        </>
      )}
    </button>
  );
};

export default DesktopModeToggle;
